export default __webpack_public_path__ + "static/media/men-4.757ab5e9.jpg";